import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { RedeemCodes } from "@apis/index";
import { toast } from "react-toastify";
import Input from "@components/fields/input";
import Button from "@components/button";
import { useModal } from "@context/ModalContext";

interface GenerateBatchModalProps {
  onSuccess: () => void;
}

const GenerateBatchModal: React.FC<GenerateBatchModalProps> = ({ onSuccess }) => {
  const { hideModal } = useModal();

  const handleGenerate = async (values: {
    batchName: string;
    startTime: string;
    endTime: string;
  }) => {
    const promise = RedeemCodes.generate(values);
    await toast.promise(promise, {
      pending: "Generating 10,000 codes...",
      success: "Batch generated successfully!",
      error: "Error generating batch",
    });
    hideModal();
    onSuccess();
  };

  return (
    <div style={{ padding: "10px" }}>
      <h2
        style={{
          fontSize: "1.25rem",
          fontWeight: 600,
          color: "#1e293b",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        Generate New Batch (10,000 Codes)
      </h2>
      <Formik
        initialValues={{
          batchName: "",
          startTime: "",
          endTime: "",
        }}
        validationSchema={Yup.object().shape({
          batchName: Yup.string().required("Batch Name is required"),
          startTime: Yup.date().required("Start Time is required"),
          endTime: Yup.date().required("End Time is required"),
        })}
        onSubmit={handleGenerate}
      >
        {({ isSubmitting }) => (
          <Form>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Input
                name="batchName"
                label="Batch Name"
                placeholder="e.g. New Year Campaign 2024"
              />
              <div style={{ display: "flex", gap: "20px" }}>
                <Input
                  type="datetime-local"
                  name="startTime"
                  label="Active From"
                  styleWrapper="flex: 1"
                />
                <Input
                  type="datetime-local"
                  name="endTime"
                  label="Active To (Info only)"
                  styleWrapper="flex: 1"
                />
              </div>
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                <Button
                  title="Cancel"
                  type="button"
                  onClick={hideModal}
                  styleButton="background: #eee; color: #333;"
                />
                <Button
                  title="Generate"
                  type="submit"
                  disabled={isSubmitting}
                  styleButton="background: #1a1a1a; color: #fff;"
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default GenerateBatchModal;
